// 29-09 — Pau vio a las 12:14 un fallo ya arreglado: su pestaña llevaba abierta desde antes de dos despliegues
// y seguía ejecutando el código viejo (index.html no se cachea, pero una pestaña abierta no lo vuelve a pedir).
// Cada bundle sabe su propio nombre (lleva su huella); el index.html vivo dice cuál es el actual. Si ya no es el
// nuestro, hay versión nueva. Sin ficheros nuevos ni pasos de build: lo sirve el mismo index.html.
import { useEffect, useState } from 'react';

const CADA_MS = 60_000;

/** El nombre de este bundle (`index-XXXX.js`), o null en desarrollo (Vite sirve los módulos sueltos). */
export function nombreDeEsteBundle(url: string = import.meta.url): string | null {
  const m = /\/assets\/(index-[A-Za-z0-9_-]+\.js)(?:$|\?)/.exec(new URL(url).pathname);
  return m ? m[1]! : null;
}

/** true si el index.html que sirve ahora el panel ya no carga este bundle. */
export function esOtraVersion(indexHtml: string, propio: string): boolean {
  return /\/assets\/index-[A-Za-z0-9_-]+\.js/.test(indexHtml) && !indexHtml.includes(`/assets/${propio}`);
}

export function useVersionNueva(): boolean {
  const [nueva, setNueva] = useState(false);
  useEffect(() => {
    const propio = nombreDeEsteBundle();
    if (!propio) return;
    let parado = false;
    const mirar = async () => {
      if (parado || document.visibilityState !== 'visible') return;
      try {
        const r = await fetch('/', { cache: 'no-store', credentials: 'same-origin' });
        if (r.ok && esOtraVersion(await r.text(), propio)) setNueva(true);
      } catch {
        // sin red: se vuelve a mirar en el próximo intervalo
      }
    };
    const t = setInterval(() => void mirar(), CADA_MS);
    document.addEventListener('visibilitychange', mirar);
    void mirar();
    return () => {
      parado = true;
      clearInterval(t);
      document.removeEventListener('visibilitychange', mirar);
    };
  }, []);
  return nueva;
}
